import { ConnectionNames } from "../../../Contracts";
import { OBQuerySubscribersStore } from "../OBQuerySubscribersStore";
import { connectWithSubscriptions, connectionCloseHandler, connectionStore, getSubscribersForQueryId } from "../../../Common";
function message(x) {
    return getSubscribersForQueryId(OBQuerySubscribersStore, x.id).map(y => {
        if (typeof x.error !== "undefined" && typeof y.onError === "function") {
            y.onError(x.error.data);
        }
        else if (typeof x.result !== "undefined") {
            y.onData(x.result);
        }
        return y;
    });
}
function open(x) {
    // code available only in debug builds is excluded from coverage
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development") {
        console.warn("Opened socket:", x);
    }
}
function error(x) {
    OBQuerySubscribersStore.getAllConnections().map(y => y.onError && y.onError(x));
}
function close(x) {
    let res = [false, -1];
    // code available only in debug builds is excluded from coverage
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development") {
        console.warn("Closed socket:", x);
    }
    const conn = connectionStore.get(ConnectionNames.openBets);
    if (conn) {
        res = connectionCloseHandler(1000, connectWithSubscriptions.bind(undefined, conn, OBQuerySubscribersStore), x);
    }
    return res;
}
export function openBetsSocketConnectionHandlers(rqFormatter, rsFormatter) {
    return {
        open, close, message, error,
        requestFormatter: rqFormatter,
        responseFormatter: rsFormatter,
    };
}
//# sourceMappingURL=OpenBetsSocketConnectionHandlers.js.map